/* eslint-disable angular/log */
// Polyfills
import './polyfills/structuredClone.js';
// base styles
import angular from 'angular';
import AngularAnimateMod from 'angular-animate';
import AngularCookiesMod from 'angular-cookies';
import AngularMessagesMod from 'angular-messages';
import AngularSanitizeMod from 'angular-sanitize';
// third party modules
import AngularLocalStorageMod from 'angular-local-storage';
import QS from 'qs';
import ToastrMod from '@Modules/toastr/index.js';
import CollapseMod from '@Vendor/ui-bs/src/collapse/index.js';
import ModalMod from '@Vendor/ui-bs/src/modal/index-nocss.js';
import TooltipMod from '@Vendor/ui-bs/src/tooltip/index-nocss.js';
import configCompileProvider from '@Common/configCompileProvider.js';
import configCookiesProvider from '@Common/configCookiesProvider.js';
import configHttpInterceptors from '@Common/configHttpInterceptor.js';
import configLocalStorage from '@Common/configLocalStorageProvider.js';
import configLogProvider from '@Common/configLogProvider.js';
import configMisc from '@Common/configMisc.js';
import configTextAngularConfig from '@Common/configTextAngularOptions.js';
import configToastr from '@Common/configToastr.js';
import configTooltipProvider from '@Common/configTooltipProvider.js';
import configUibModalDecorator from '@Common/configUibModalDecorator.js';
import httpDefaults from '@Common/runHttpDefaults.js';
// run
import onLoginRequiredEvent from '@Common/runOnAuthEvents.js';
import stateOnBeforeHook from '@Common/runOnBeforeHook.js';
import stateOnErrorHook from '@Common/runOnErrorHook.js';
import onServiceUnavailable from '@Common/runOnEventServiceUnavailable.js';
import stateOnStartHook from '@Common/runOnStartHook.js';
import stateOnSuccessHook from '@Common/runOnSuccessHook.js';
import onUnhandledRejection from '@Common/runOnUnhandledRejection.js';
import {installDbg} from '@Common/devtools.js';
// cmps
import LoginFormCmpMod from '@Components/login-form/login-form.cmp.js';
import ModalAlertCmpMod from '@Components/modal-alert/modal-alert.cmp.js';
import RenderAlertCompMod from '@Components/render-alert/render-alert.cmp.js';
import RenderPreCmpMod from '@Components/render-pre/RenderPre.js';
import ServiceUnavailableCmpMod from '@Components/service-unavailable/service-unavailable.cmp.js';
import SingleRowCmpMod from '@Components/single-row/single-row.cmp.js';
// cmps
import SplashLoader from '@Components/splash-loader/splash-loader.cmp.js';
import SvgIconCmpMod from '@Components/svg-icon/svg-icon.cmp.js';
import AuthConstantsMod from '@Constants/auth.constants.js';
import DateConstantsMod from '@Constants/date-formats.constants.js';
import IndexConstantsEnvMod from '@Constants/env.constants.js';
import IndexConstantsMod from '@Constants/index.constants.js';
// directives
import FallbackSrcDrtMod from '@Directives/fallback-src.drt.js';
import ImagePreloadDrtMod from '@Directives/image-preload.drt.js';
// filters
import FormatPhoneFltMod from '@Filters/formatPhone.flt.js';
// svc
import HtmlUtilsSvcMod from '@Services/HtmlUtils.svc.js';
import AuthSvcMod from '@Services/Auth.svc.js';
import ThemingSvcMod from '@Services/ColorTheming.svc.js';
import ConsultationSvcMod from '@Services/Consultation.svc.js';
import CustomerScvMod from '@Services/Customer.svc.js';
import DOMHelpersSvcMod from '@Services/DOMHelpers.svc.js';
import FeatureFlagsSvcMod from '@Services/FeatureFlags.svc.js';
import HttpBuffer from '@Services/HttpBuffer.js';
import InterceptorAuth from '@Services/InterceptorAuth.js';
import InterceptorMock from '@Services/InterceptorMock.js';
import InterceptorStatusCodes from '@Services/InterceptorStatusCode.js';
import IntercomSvcMod from '@Services/Intercom.svc.js';
import MetricsSvcMod from '@Services/Metrics.svc.js';
import ModalHelperSvcMod from '@Services/ModalHelper.svc.js';
import NavSvcMod from '@Services/Nav.svc.js';
import NotifySubscribeSvcMod from '@Services/NotifySubscribe.svc.js';
import ProposalSvcMod from '@Services/Proposal.svc.js';
import ProviderSettingsSvcMod from '@Services/ProviderSettings.svc.js';
import QueuePromisesSvcMod from '@Services/QueuePromises.svc.js';
import RoutesResolveSvcMod from '@Services/RoutesResolve.svc.js';
import ScriptsSvcMod from '@Services/Scripts.svc.js';
import ServiceProviderSvcMod from '@Services/ServiceProvider.svc.js';
import ServiceProviderUserSvcMod from '@Services/ServiceProviderUser.svc.js';
import StorageStateSvcMod from '@Services/StorageState.svc.js';
import StorageSvcMod from '@Services/Storage.svc.js';
import TextUtilsSvcMod from '@Services/TextUtils.svc.js';
import UtilitySvcMod from '@Services/Utility.svc.js';
import StorageDbSvcMod from '@Modules/db-storage/module.storage.mod.js';
import AngularUiRouter from '@uirouter/angularjs';
import './index.scss';
//
import {
	addDays,
	addYears,
	compareAsc,
	differenceInHours,
	differenceInMinutes,
	format,
	formatISO,
	fromUnixTime,
	getUnixTime,
	isBefore,
	parseISO,
	startOfYear,
	subDays,
	subMonths,
	subYears,
	toDate,
} from 'date-fns';
// constants
import OcLazyLoadMod from 'oclazyload';
import textAngular from 'textangular';
// controllers
import MainCtrMod from './app/controllers/main.controller.js';
// config
import routesConfig from './routes.js';
// #endregion
let appMod = angular
	.module('ocaApp', [
		// third party
		AngularUiRouter,
		AngularAnimateMod,
		AngularCookiesMod,
		AngularSanitizeMod,
		AngularMessagesMod,
		AngularLocalStorageMod,
		OcLazyLoadMod,
		textAngular,
		ModalMod,
		CollapseMod,
		TooltipMod,
		ToastrMod,
		// svc
		StorageDbSvcMod,
		FeatureFlagsSvcMod,
		AuthSvcMod,
		DOMHelpersSvcMod,
		ServiceProviderUserSvcMod,
		ProviderSettingsSvcMod,
		UtilitySvcMod,
		TextUtilsSvcMod,
		ConsultationSvcMod,
		StorageSvcMod,
		CustomerScvMod,
		NavSvcMod,
		NotifySubscribeSvcMod,
		ServiceProviderSvcMod,
		ThemingSvcMod,
		QueuePromisesSvcMod,
		ModalHelperSvcMod,
		MetricsSvcMod,
		IntercomSvcMod,
		RoutesResolveSvcMod,
		ScriptsSvcMod,
		DateConstantsMod,
		IndexConstantsMod,
		IndexConstantsEnvMod,
		AuthConstantsMod,
		ProposalSvcMod,
		StorageStateSvcMod,
		HtmlUtilsSvcMod,
		// filters
		FormatPhoneFltMod,
		// ctrl
		MainCtrMod,
		// cmp
		LoginFormCmpMod,
		ServiceUnavailableCmpMod,
		ModalAlertCmpMod,
		RenderAlertCompMod,
		RenderPreCmpMod,
		SingleRowCmpMod,
		SvgIconCmpMod,
		// drt
		FallbackSrcDrtMod,
		ImagePreloadDrtMod,
	])
	// config
	.config(routesConfig)
	.config(configHttpInterceptors)
	.config(configLocalStorage)
	.config(configCookiesProvider)
	.config(configCompileProvider)
	.config(configLogProvider)
	.config(configMisc)
	.config(configToastr)
	.config(configTooltipProvider)
	.config(configUibModalDecorator)
	.config(configTextAngularConfig)
	// run
	.run(onLoginRequiredEvent)
	.run(onServiceUnavailable)
	.run(httpDefaults)
	.run(stateOnBeforeHook)
	.run(stateOnStartHook)
	// .run(stateChangeSuccess)
	.run(stateOnSuccessHook)
	// .run(stateChangeError)
	.run(stateOnErrorHook)
	.run(onUnhandledRejection)
	.run(ScriptsSvc => {
		'ngInject';
		ScriptsSvc.init();
	})
	.run(ThemingService => {
		'ngInject';
		ThemingService.initTheme();
	})
	.component('splashLoader', SplashLoader)
	// factories
	.factory('InterceptorAuth', InterceptorAuth.create)
	.factory('InterceptorMock', InterceptorMock.create)
	.factory('InterceptorStatusCodes', InterceptorStatusCodes.create)
	// services
	.service('HttpBuffer', HttpBuffer)
	// constants
	.constant('dateFns', {
		format,
		formatISO,
		toDate,
		addYears,
		addDays,
		parseISO,
		subDays,
		subMonths,
		subYears,
		startOfYear,
		compareAsc,
		differenceInMinutes,
		differenceInHours,
		getUnixTime,
		fromUnixTime,
		isBefore,
	})
	.constant('QsSvc', QS);

// enable TRANSITION tracing
if (process.env.NODE_ENV !== 'production') {
	appMod.run($trace => $trace.enable('TRANSITION'));
}

// Dev tools: console.get, console.list, console.props, console.last
installDbg();

const SW_RELOAD_KEY = 'sw-reloaded';
// bootstrap manually with strict DI
function bootstrapApplication() {
	// Only install service worker in production builds
	if (process.env.NODE_ENV === 'production') {
		import('@lcdp/offline-plugin/runtime.js').then(OfflinePluginRuntime => {
			OfflinePluginRuntime.install({
				// Update started in background
				onInstalled: obj => {
					console.info(`[SW]:onInstalled: `, obj.source);
					console.info(`[SW]:onInstalled: ${window.location.pathname}`);
					localStorage.removeItem(SW_RELOAD_KEY);
				},
				onUpdating: obj => {
					console.info(`[SW]:onUpdating: `, obj.source);
					console.info(`[SW]:onUpdating: ${window.location.pathname}`);
				},
				// Update is ready to be applied
				onUpdateReady: obj => {
					console.info(`[SW]:onUpdateReady: `, obj.source);
					console.info(`[SW]:onUpdateReady: ${window.location.pathname}`);
					OfflinePluginRuntime.applyUpdate();
				},
				// Update was applied
				onUpdated: obj => {
					console.info(`[SW]:onUpdated: : `, obj.source);
					console.info(`[SW]:onUpdated: ${window.location.pathname}`);
					// Guard against infinite reload loop: only reload once per update
					if (!localStorage.getItem(SW_RELOAD_KEY)) {
						localStorage.setItem(SW_RELOAD_KEY, '1');
						window.location.reload();
					}
				},
				// Update failed
				onUpdateFailed: obj => {
					console.info(`[SW]:onUpdateFailed: `, obj.source);
					console.info(`[SW]:onUpdateFailed: ${window.location.pathname}`);
				},
			});
			// Force SW update check on every app boot (browser default is 24h)
			OfflinePluginRuntime.update();
		});
	}

	const appContainer = document.getElementById('ocaApp');
	const app = angular.bootstrap(appContainer, ['ocaApp']);
	// enable strict dependency injection
	app.annotate = angular.injector(['ng']).annotate;

	// define the event handler
	const $rootScope = app.get('$rootScope');
	$rootScope.$on('appBootstrapped', () => {
		const splashLogoElm = document.getElementById('splashLogo');
		if (splashLogoElm) splashLogoElm.classList.add('fade');

		setTimeout(() => {
			const loadingSpinnerElm = document.getElementById('loadingSpinner');
			if (loadingSpinnerElm) loadingSpinnerElm.style.display = 'none';
		}, 2000);
	});

	// Emit the event after defining the handler
	$rootScope.$emit('appBootstrapped');
}

document.addEventListener('DOMContentLoaded', () => {
	const loadingSpinnerElm = document.getElementById('loadingSpinner');
	if (loadingSpinnerElm) loadingSpinnerElm.style.display = 'block';

	if (!bootstrapApplication.hasRun) {
		bootstrapApplication();
		bootstrapApplication.hasRun = true;
	}
});

export default (appMod = appMod.name);
